import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql } from "gatsby";
import { PrismicRichText } from "@prismicio/react";

const Holder = styled.div`
  color: black;
`;

const ArticleGrid = styled.div`


@media (${(props) => props.theme.breakpoints.md}) {
    display: grid;
    grid-template-columns: 2fr 3fr;
  }
`;

const ArticleBody = styled.div`
  grid-column: 2 / 3;
  ${(props) => props.theme.fluidType(1)}

  @media (${(props) => props.theme.breakpoints.md}) {
    padding-left: 0.5rem;
    ${(props) => props.theme.fluidType(0.5)}
  }
`;

const Heading = styled.div`
  color: #FF00FF;
  font-family: "Universal Sans", sans-serif;
  font-weight: bold;
`;

const Text = styled.div`
  font-family: "Roboto Serif", serif;
`;

const SliceTextBlockPerspective = ({ slice }) => {

  const heading = slice.primary.heading.text;
  const text = slice.primary.text.richText;

  return (
    <Holder>
      <ArticleGrid>
        <ArticleBody>
          <Heading>
            <p>{heading}</p>
          </Heading>
          <Text>
            <PrismicRichText field={text} />
          </Text>
        </ArticleBody>
      </ArticleGrid>
    </Holder>
  );
};

SliceTextBlockPerspective.propTypes = {
  slice: PropTypes.object.isRequired,
};

export default SliceTextBlockPerspective;

export const query = graphql`
  fragment SliceTextBlockPerspective on PrismicPerspectiveDataBodyTextBlock {
    id
    slice_type
      primary {
        heading {
          richText
          text
        }
        text {
          richText
        }
      }
  }
`;